import { Component, inject, OnInit } from '@angular/core';
import { TenureDropDownSearchConfig, TenureTitle } from '../../model/tenure.model';
import { InputProperty, TabGroupConfig } from '../../model/form.model';
import { TenureBasicTabSchema, TenureDiscretionaryTabSchema } from '../../model/tenure-tabs.model';
import { TenureAdjustmentComponent } from './tenure-adjustment/tenure-adjustment.component';
import { GroupedPageContainerComponent } from '../../layout/grouped-page-container/grouped-page-container.component';
import { API_STATUS, ApiEnvNames, ERROR_RESPONSE, SearchConfig } from '../../model/api.model';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-tenure',
  standalone: true,
  imports: [GroupedPageContainerComponent],
  templateUrl: './tenure.component.html',
  styleUrl: './tenure.component.scss',
})
export class TenureComponent implements OnInit {
  private readonly service = inject(CommonService);
  title = TenureTitle;

  groups: TabGroupConfig[] = [
    { label: 'Base Tenure', tabs: TenureBasicTabSchema.map(tab => ({ ...tab, inputs: { ...tab.inputs } })) },
    { label: 'Discretionary Tenure', tabs: TenureDiscretionaryTabSchema.map(tab => ({ ...tab, inputs: { ...tab.inputs } })) },
  ];

  ngOnInit(): void {
    if (this.service.isTenureAdmin) {
      this.groups = [
        ...this.groups,
        { label: 'Tenure Adjustment', component: TenureAdjustmentComponent, inputs: {} }
      ];
    }
    this.fetchOptions();
  }

  private fetchOptions(): void {
    const mapFieldValues = (arr: any[], labelKey: string, valueKey: string) =>
      arr.map((item: any) => ({ fieldLabel: item[labelKey], fieldValue: item[valueKey] }));

    const tenureOptions: any = { toyotaRegions: [], dealerOptions: [], jobs: [], ttenDealers: [] };
    const searchConfig: SearchConfig = structuredClone(TenureDropDownSearchConfig);

    this.service.getDataFromDataSource(searchConfig, ApiEnvNames['Tenure']).then(res => {
      if (res['status'] === API_STATUS['Success']) {
        const result = res['result'][0];
        if (result['toyotaRegions']){ tenureOptions['toyotaRegions'] = mapFieldValues(result['toyotaRegions'], 'areaName', 'area')};
        if (result['dealers']){ tenureOptions['dealerOptions'] = mapFieldValues(result['dealers'], 'dealer', 'dealerCode')};
        if (result['jobs']){ tenureOptions['jobs'] = mapFieldValues(result['jobs'], 'jobDescription', 'jobDescription')};
        if (result['ttenDealers']){ tenureOptions['ttenDealers'] = mapFieldValues(result['ttenDealers'], 'dealer', 'dealerCode')};
      }
      this.updateTabOptions(tenureOptions);
    }).catch(err => {
      console.info(ERROR_RESPONSE['layoutErrorPrefix'], err);
      this.updateTabOptions(tenureOptions);
    });
  }

  private updateTabOptions(options: any): void {
    this.groups = this.groups.map(group => ({
      ...group,
      tabs: group.tabs?.map(tab =>
        'options' in tab.inputs
          ? { ...tab, inputs: { ...tab.inputs, options } as InputProperty }
          : tab
      ),
    }));
  }
}
